import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import 'ziphy-web-shared/basic/assets/styles/animations.scss';
import 'ziphy-web-shared/basic/assets/styles/flags.scss';
import { ScopeContext } from 'ziphy-web-shared/basic/context/ScopeContext';
import { AlertsViewer, TooltipsViewer } from 'ziphy-web-shared/basic/lib/utilities';
import { ModalViewer } from 'ziphy-web-shared/basic/lib/utilities/modals';
import 'ziphy-web-shared/basic/lib/utilities/modals/Modal.scss';
import 'ziphy-web-shared/basic/utils/charts';
const PluginsProvider = ({ alerts = true, modals = true, tooltips = true, children, }) => {
    return (_jsx(_Fragment, { children: _jsxs(ScopeContext.Provider, Object.assign({ value: { scope: 0 } }, { children: [children, alerts && _jsx(AlertsViewer, {}), modals && _jsx(ModalViewer, {}), tooltips && _jsx(TooltipsViewer, {})] })) }));
};
export default PluginsProvider;
